/* ----------------------------------------------------------------------------------- 
   Name:				AQDConcurrencyCheck.js
   Created:			Matthew Zalewski
   Date:				16 December 2009
   Description:	Prepares a form (or any other container element) for concurrency check.
  						  This only works if the function is called before any data is modified by the user.
*/
$.extend({
	addModelState: function(formId, prefix, model) {
		if (model == undefined) {
			model = prefix;
			prefix = "";
		}
		var form = $('#' + formId);

		var modelStateName = prefix + ".modelState";
		if (prefix == "")
			modelStateName = "modelState";
		$('<input type="hidden" value="" name="' + modelStateName + '" id="' + modelStateName + '" />').val("true").appendTo(form);
		for (var key in model) {
			var dateRegex = /\Date\(([0-9]*)\)\//;
			var value = model[key];
			if (dateRegex.test(model[key])) {

				var date = new Date(parseInt(RegExp.$1));

				value = $.datepicker.formatDate('yy-mm-dd', date);
			}
			if (value == null)
				value = '';
			$('<input type="hidden" value="" name="' + key + '.original" id="' + key + '_original" />').val(value).appendTo(form);
		}
		//		form.find('input[type="text"],input[type="hidden"],select,input[type="password"]').each(function() {
		//			// Look for .original
		//			var name = $(this).attr('name');

		//			if (!name.endsWith('.original')) {
		//				var modelKey = prefix + "." + name;
		//				if (prefix == "")
		//					modelKey = name;
		//				if (model[modelKey] == undefined || model[modelKey] == null)
		//					return;
		//				var existingOriginalEl = form.find('input[name="' + name + '.original"]');
		//				if (existingOriginalEl.length == 0) {
		//					var dateRegex = /\Date\(([0-9]*)\)\//;
		//					var value = model[modelKey];
		//					if (dateRegex.test(model[modelKey])) {

		//						var date = new Date(parseInt(RegExp.$1));

		//						value = $.datepicker.formatDate('yy-mm-dd', date);
		//					}
		//					$('<input type="hidden" value="" name="' + name + '.original" id="' + name + '.original" />').val(value).appendTo($(this).parent());
		//				}
		//			}
		//		});
		//		form.find('textarea').each(function() {
		//			// Look for .original
		//			var name = $(this).attr('name');
		//			if (!name.endsWith('.original')) {
		//				var modelKey = prefix + "." + name;
		//				if (prefix == "")
		//					modelKey = name;
		//				if (model[modelKey] == undefined || model[modelKey] == null)
		//					return;

		//				var existingOriginalEl = form.find('input[name="' + name + '.original"]');
		//				if (existingOriginalEl.length == 0) {
		//					var dateRegex = /\Date\(([0-9]*)\)\//;
		//					var value = model[modelKey];
		//					if (dateRegex.test(model[modelKey])) {

		//						var date = new Date(parseInt(RegExp.$1));

		//						value = $.datepicker.formatDate('yy-mm-dd', date);
		//					}
		//					$('<input type="hidden" value="" name="' + name + '.original" id="' + name + '.original" />').val(value).appendTo($(this).parent());
		//				}
		//			}
		//	});

	}
});
$.extend($.fn, {
	
	prepareForConcurrencyCheck: function() {
		var form = $(this);
		$(this).find('input[type="text"],input[type="hidden"],select,input[type="password"]').each(function() {
			// Look for .original
			var name = $(this).attr('name');
			if (!name.endsWith('.original')) {
				var existingOriginalEl = form.find('input[name="' + name + '.original"]');
				if (existingOriginalEl.length == 0) {
					$('<input type="hidden" value="" name="' + name + '.original" id="' + name + '.original" />').val($(this).val()).appendTo($(this).parent());
				}
			}
		});
		$(this).find('textarea').each(function() {
			// Look for .original
			var name = $(this).attr('name');
			if (!name.endsWith('.original')) {
				var existingOriginalEl = form.find('input[name="' + name + '.original"]');
				if (existingOriginalEl.length == 0) {
					$('<input type="hidden" value="" name="' + name + '.original" id="' + name + '.original" />').val($(this).text()).appendTo($(this).parent());
				}
			}
		});

	}
});
